export default {
  path: 'Taskaudit',
  component: () => import(/* webpackChunkName: "category-list" */ '@/pages/audit/Taskaudit'),
  meta: {title: '任务审核'},
  // children: [{
  //   path: ':invoicing_id/view',
  //   component: () => import( /* webpackChunkName: "individual-view" */ '@/pages/audit/CreateEdit'),
  //   meta: {
  //     title: '个体户发票代开详情'
  //   },
  // }]
  children: [{
    path: 'personnelList',
    component: () => import( /* webpackChunkName: "individual-view" */ '@/pages/audit/personnelList/index'),
    meta: {
      title: '人员审核'
    },
  },{
    path: 'deliveryPersonnelDetail',
    component: () => import( /* webpackChunkName: "individual-view" */ '@/pages/audit/personnelList/detail'),
    meta: {
      title: '详情'
    },
  },{
    path: 'privatePersonnelList',
    component: () => import( /* webpackChunkName: "individual-view" */ '@/pages/audit/privatePersonnelList/index'),
    meta: {
      title: '人员审核'
    },
  },]
}